import PropTypes from 'prop-types';
import React from 'react';

class OverlayContext extends React.Component {
  static displayName = 'OverlayContext';

  static propTypes = {
    children: PropTypes.node,
    bounds: PropTypes.object,
    positionToPixel: PropTypes.func.isRequired,
  };

  static childContextTypes = {
    bounds: PropTypes.object,
    positionToPixel: PropTypes.func,
  };

  getChildContext() {
    return {
      bounds: this.props.bounds,
      positionToPixel: this.props.positionToPixel,
    };
  }

  render() {
    return <div>{this.props.children}</div>;
  }
}

export default OverlayContext;



// WEBPACK FOOTER //
// ./src/common/components/BetterMap/OverlayContext.js